import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // get ProductListByProvider
  getProductListByProviderDataSuccess,
  getProductListByProviderDataFailed,
  getProductListByProviderData,
  // get ProductType List Api
  getProductListTypeApiData,
  getProductTypeListApiDataSuccess,
  getProductTypeListApiDataFailed,

  // pharmacy booking Order List
  getPharmacyBookingOrderListApiData,
  getPharmacyBookingOrderListApiSuccess,
  getPharmacyBookingOrderListApiFailed,

  // Update pharmacy status
  updatePharmacyBookingOrderListApiData,
  updatePharmacyBookingOrderListSuccess,
  updatePharmacyBookingOrderFailed,

  // view product Details
  getProductDeatilsApiData,
  getProductDeatilsApisSuccess,
  getProductDeatilsApiFailed,
  // View Booking Deatils Api data
  getBookingDeatilsApidata,
  getBookingDeatilsApiSuccess,
  getBookingDeatilsApiFailed,
  // appointment Status
  getAppointMentStatusApiData,
  getAppointMentStatusApiSuccess,
  getAppointMentStatusApiFailed,
  //Update order by pharmacy
  updatePharmacyBookingListApiData,
  updatePharmacyBookingListSuccess,
  updatePharmacyBookingListFailed,

  // product Listing by productType
  getProductListByProductTypeApiData,
  getProductListByProductTypeDataSuccess,
  getProductListByProductTypeDataFailed,

  // get All Types Category
  getAllTypePharmacyCategoriesApiData,
  getAllTypePharmacyCategoriesApiSucess,
  getAllTypePharmacyCategoriesApiFailed,

  // Add product category
  addProductByProductTypeApiData,
  addProductByProductTypeApiSucess,
  addProductByProductTypeApiFailed,

  // get Sizes
  getPharmacySizesApiData,
  getPharmacySizesApiDataSuccess,
  getPharmacySizesApiDataFailed,

  // get List Composition
  getListCompositionApiData,
  getListCompositionDataSuccess,
  getListCompositionDataFailed,

  // get List Sub Types Api Data
  getListSubTypesApiData,
  getListSubTypesApiSuccess,
  getListSubTypesApiFailed,
} from './slice'
import { API } from 'src/pharmacy/services/index'

function* getProductListByProvider({ payload }) {
  try {
    const response = yield call(API.managePharmacy.getProductListByProvider, payload)
    if (
      response?.status === 200 &&
      response?.data &&
      response?.data?.code === 0 &&
      response?.data?.error === false
    ) {
      yield put(getProductListByProviderDataSuccess({ payload: response?.data }))
    } else {
      yield put(getProductListByProviderDataFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getProductListByProviderDataFailed({ message: error?.message }))
  }
}

function* getProductListTypeApi({ type, payload }) {
  try {
    const response = yield call(API.managePharmacy.getProductTypeList, payload)
    if (response.data && response.status === 200) {
      yield put(getProductTypeListApiDataSuccess({ payload: response?.data }))
    } else {
      yield put(getProductTypeListApiDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getProductTypeListApiDataFailed({ message: error?.message }))
  }
}
function* getPharmacyBookingOrderListApi({ type, payload }) {
  try {
    const response = yield call(API.managePharmacy.getPharmacyBookingOrderList, payload)
    if (response.data && response.status === 200) {
      yield put(getPharmacyBookingOrderListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getPharmacyBookingOrderListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getPharmacyBookingOrderListApiFailed({ message: error?.message }))
  }
}

function* getProductDeatilsApi({ type, payload }) {
  try {
    const response = yield call(API.managePharmacy.getProductDeatils, payload)
    if (response.data && response.status === 200) {
      yield put(getProductDeatilsApisSuccess({ payload: response?.data }))
    } else {
      yield put(getProductDeatilsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getProductDeatilsApiFailed({ message: error?.message }))
  }
}

function* getBookingDeatilsApi({ type, payload }) {
  try {
    const response = yield call(API.managePharmacy.getBookingDeatils, payload)
    if (response.data && response.status === 200) {
      yield put(getBookingDeatilsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getBookingDeatilsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getProductDeatilsApiFailed({ message: error?.message }))
  }
}
function* getAppointMentStatusApi({ type, payload }) {
  try {
    const response = yield call(API.managePharmacy.getAppointMentStatus, payload)
    if (response.data && response.status === 200) {
      yield put(getAppointMentStatusApiSuccess({ payload: response?.data }))
    } else {
      yield put(getAppointMentStatusApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getProductDeatilsApiFailed({ message: error?.message }))
  }
}
function* updatePharmacyBookingListApi({ type, payload }) {
  try {
    const response = yield call(API.managePharmacy.updatePharmacyBookingList, payload)
    if (response.data && response.status === 200) {
      yield put(updatePharmacyBookingListSuccess({ payload: response?.data }))
    } else {
      yield put(updatePharmacyBookingListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updatePharmacyBookingListFailed({ message: error?.message }))
  }
}
function* getProductListByProductTypeApi({ type, payload }) {
  try {
    const response = yield call(API.managePharmacy.getProductListByProductType, payload)
    if (response.data && response.status === 200) {
      yield put(getProductListByProductTypeDataSuccess({ payload: response?.data }))
    } else {
      yield put(getProductListByProductTypeDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getProductListByProductTypeDataFailed({ message: error?.message }))
  }
}
function* getAllTypePharmacyCategoriesApi({ type, payload }) {
  try {
    const response = yield call(API.managePharmacy.getAllTypePharmacyCategories, payload)
    if (response.data && response.status === 200) {
      yield put(getAllTypePharmacyCategoriesApiSucess({ payload: response?.data }))
    } else {
      yield put(getAllTypePharmacyCategoriesApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getAllTypePharmacyCategoriesApiFailed({ message: error?.message }))
  }
}
function* addProductByProductTypeApi({ type, payload }) {
  try {
    const response = yield call(API.managePharmacy.addProductByProductType, payload)
    if (response.data && response.status === 200) {
      yield put(addProductByProductTypeApiSucess({ payload: response?.data }))
    } else {
      yield put(addProductByProductTypeApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addProductByProductTypeApiFailed({ message: error?.message }))
  }
}
function* getPharmacySizesApi({ type, payload }) {
  try {
    const response = yield call(API.managePharmacy.getPharmacySizes, payload)
    if (response.data && response.status === 200) {
      yield put(getPharmacySizesApiDataSuccess({ payload: response?.data }))
    } else {
      yield put(getPharmacySizesApiDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getPharmacySizesApiDataFailed({ message: error?.message }))
  }
}
function* getListCompositionApi({ type, payload }) {
  try {
    const response = yield call(API.managePharmacy.getListComposition, payload)
    if (response.data && response.status === 200) {
      yield put(getListCompositionDataSuccess({ payload: response?.data }))
    } else {
      yield put(getListCompositionDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getListCompositionDataFailed({ message: error?.message }))
  }
}
function* getListSubTypesApi({ type, payload }) {
  try {
    const response = yield call(API.managePharmacy.getListSubTypes, payload)
    if (response.data && response.status === 200) {
      yield put(getListSubTypesApiSuccess({ payload: response?.data }))
    } else {
      yield put(getListSubTypesApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getListSubTypesApiFailed({ message: error?.message }))
  }
}

function* authSaga() {
  yield takeEvery(getProductListByProviderData, getProductListByProvider)
  yield takeEvery(getProductListTypeApiData, getProductListTypeApi)
  yield takeEvery(getPharmacyBookingOrderListApiData, getPharmacyBookingOrderListApi)
  yield takeEvery(getProductDeatilsApiData, getProductDeatilsApi)
  yield takeEvery(getBookingDeatilsApidata, getBookingDeatilsApi)
  yield takeEvery(getAppointMentStatusApiData, getAppointMentStatusApi)
  yield takeEvery(updatePharmacyBookingListApiData, updatePharmacyBookingListApi)
  yield takeEvery(getProductListByProductTypeApiData, getProductListByProductTypeApi)
  yield takeEvery(getAllTypePharmacyCategoriesApiData, getAllTypePharmacyCategoriesApi)
  yield takeEvery(addProductByProductTypeApiData, addProductByProductTypeApi)
  yield takeEvery(getPharmacySizesApiData, getPharmacySizesApi)
  yield takeEvery(getListCompositionApiData, getListCompositionApi)
  yield takeEvery(getListSubTypesApiData, getListSubTypesApi)
}

export default authSaga
